import React from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { Switch } from '../../ui/switch';
import { COLORES_HILO, UBICACIONES_BORDADO } from './tiendaAdminApi';

const MAX_COLORES = 12;

const FilaColor = ({ color, onCambiar, onEliminar, testId }) => (
  <div className="flex items-center gap-2" data-testid={testId}>
    <input type="color" value={color.hex} onChange={e => onCambiar({ ...color, hex: e.target.value.toUpperCase() })}
      className="h-9 w-11 shrink-0 cursor-pointer rounded border border-slate-300 p-0.5" aria-label="Color del hilo" data-testid={`${testId}-hex`} />
    <input value={color.nombre} onChange={e => onCambiar({ ...color, nombre: e.target.value })} maxLength={30} placeholder="Nombre del color"
      className="min-w-0 flex-1 rounded-lg border border-slate-300 px-3 py-2 text-sm text-slate-900" data-testid={`${testId}-nombre`} />
    <button type="button" onClick={onEliminar} className="rounded-lg p-2 text-red-600 hover:bg-red-50" aria-label="Eliminar color" data-testid={`${testId}-eliminar`}>
      <Trash2 className="h-4 w-4" />
    </button>
  </div>
);

const Lugares = ({ grupo, cambiar, testId }) => {
  const alternar = (id) => {
    const lista = grupo.ubicaciones.includes(id) ? grupo.ubicaciones.filter(u => u !== id) : [...grupo.ubicaciones, id];
    if (lista.length) cambiar({ ubicaciones: UBICACIONES_BORDADO.map(u => u.id).filter(u => lista.includes(u)) });
  };
  return (
    <div className="space-y-1.5">
      <p className="text-sm font-medium text-slate-700">Lugares que puede elegir el cliente</p>
      <div className="flex flex-wrap gap-4">
        {UBICACIONES_BORDADO.map(u => (
          <label key={u.id} className="flex items-center gap-2 text-sm text-slate-700">
            <input type="checkbox" checked={grupo.ubicaciones.includes(u.id)} onChange={() => alternar(u.id)} className="h-4 w-4 accent-emerald-600" data-testid={`${testId}-lugar-${u.id}`} />
            {u.titulo}
          </label>
        ))}
      </div>
      <p className="text-xs text-slate-500">Con manga corta el cliente no puede elegir el puño.</p>
    </div>
  );
};

export default function ConfigBordado({ grupo, cambiar, testId }) {
  const activar = (v) => cambiar(v
    ? { bordado: true, ubicaciones: grupo.ubicaciones?.length ? grupo.ubicaciones : UBICACIONES_BORDADO.map(u => u.id), colores_hilo: grupo.colores_hilo?.length ? grupo.colores_hilo : COLORES_HILO.map(c => ({ ...c })) }
    : { bordado: false });
  const colores = grupo.colores_hilo || [];
  const setColores = (lista) => cambiar({ colores_hilo: lista });
  return (
    <div className="space-y-4 rounded-lg border border-slate-200 bg-white p-4" data-testid={`${testId}-bordado`}>
      <label className="flex items-start gap-2 text-sm text-slate-700">
        <Switch checked={Boolean(grupo.bordado)} onCheckedChange={activar} className="mt-0.5 min-h-0 data-[state=checked]:bg-emerald-600" data-testid={`${testId}-bordado-activo`} />
        <span><span className="font-medium">Es un bordado</span><span className="block text-xs text-slate-500">El cliente ve cómo quedan en la camisa y elige el lugar y el color del hilo.</span></span>
      </label>
      {grupo.bordado && (
        <>
          <Lugares grupo={grupo} cambiar={cambiar} testId={testId} />
          <div className="space-y-2">
            <p className="text-sm font-medium text-slate-700">Colores de hilo</p>
            {colores.map((c, i) => (
              <FilaColor key={i} color={c} testId={`${testId}-color-${i}`}
                onCambiar={v => setColores(colores.map((x, j) => (j === i ? v : x)))}
                onEliminar={() => colores.length > 1 && setColores(colores.filter((_, j) => j !== i))} />
            ))}
            {colores.length < MAX_COLORES && (
              <button type="button" onClick={() => setColores([...colores, { nombre: '', hex: '#1F2A44' }])}
                className="inline-flex items-center gap-2 rounded-lg border border-dashed border-slate-400 px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50" data-testid={`${testId}-agregar-color`}>
                <Plus className="h-4 w-4" />Agregar color
              </button>
            )}
          </div>
        </>
      )}
    </div>
  );
}
